<template>
  <div class="page">
    <div class="header">
      <button @click="goBack">返回</button>
    </div>
    <div class="time">提交时间：{{ create_time }}，备注：{{ beizhu }} </div>

    <div class="list-header">
      <div>图片列表</div>
      <button class="plus" @click="triggerFile">+</button>
    </div>

    <div class="grid" @dragover.prevent>
      <div v-for="(img, idx) in imagesSorted" :key="img.id" class="card" draggable="true" @dragstart="onDragStart(idx)"
        @dragenter.prevent="onDragEnter(idx)" @dragend="onDragEnd">
        <img :src="img.thumb" class="thumb" @click="openEditor(img.id)" />
        <button class="delete" @click="onDelete(img)" title="删除">🗑️</button>
        <div class="meta vertical">
          <div class="name">{{ img.name }}</div>
        </div>
      </div>
    </div>

    <div class="history">
      <div class="hist-title">
        批改结果
        <button @click="refreshCorrections" class="refresh">刷新</button>
      </div>
      <div v-if="corrections.length" class="hist-list">
        <div v-for="(url, idx) in corrections" :key="idx" class="hist-item" style="position: relative;">
          <img :src="url" @click="reopenEditor(url)" style="cursor: pointer;" />
          <button class="delete" @click="deleteResult(url)" title="删除">🗑️</button>
        </div>
      </div>
      <div v-else class="hint">暂无批改结果</div>

      <div class="download-bar">
        <button @click="downloadAll" :disabled="!corrections.length || downloading">一键下载</button>
        <span v-if="downloading">{{ downloadProgress }} / {{ corrections.length }} 正在下载...</span>
        <span v-if="downloadDone">下载完成</span>
        <button v-if="downloadFailed.length" @click="retryDownload">重试失败项</button>
        <button @click="clearAllCorrections" :disabled="!corrections.length">清除结果</button>
      </div>
      <div class="review-bar">
        <textarea v-model="piyu" placeholder="请输入评语（可选）" class="piyu-input">{{ piyu }}</textarea>
        <button class="submit" @click="submitCorrection" :disabled="!corrections.length || submitting">完成批注</button>
      </div>
    </div>
    <input ref="hiddenInput" type="file" multiple accept="image/*" class="hidden" @change="onFileSelect" />
  </div>
</template>

<script>
export default {
  name: 'PigaiHome',
  data() {
    return {
      idParam: null,
      create_time: null,
      beizhu: null,
      uploads: [],
      images: [],
      corrections: [],
      downloading: false,
      downloadProgress: 0,
      downloadDone: false,
      downloadFailed: [],
      dragIndex: null,
      overIndex: null,
      piyu: '',
      submitting: false
    }
  },

  mounted() {
    this.idParam = this.$route.query.id || this.$route.params.id || null
    this.fetchDetail()
    window.addEventListener('correction-saved', this.fetchDetail)
    window.addEventListener('images-order-updated', this.fetchDetail)
    window.addEventListener('pigai-correction-uploaded', this.onCorrectionUploaded)
    document.addEventListener('visibilitychange', this.onVisibility)
  },

  beforeDestroy() {
    window.removeEventListener('correction-saved', this.fetchDetail)
    window.removeEventListener('images-order-updated', this.fetchDetail)
    window.removeEventListener('pigai-correction-uploaded', this.onCorrectionUploaded)
    document.removeEventListener('visibilitychange', this.onVisibility)
  },

  computed: {
    imagesSorted() {
      return [...this.images].sort((a, b) => (a.order || 0) - (b.order || 0))
    }
  },

  methods: {
    goBack() { this.$router.push('/pigaiList') },
    onVisibility() {
      if (!document.hidden) this.fetchDetail()
    },

    async fetchDetail() {
      if (!this.idParam) return
      try {
        console.log('start fetchDetail, this.idParam', this.idParam)
        const resp = await this.$http.get('admin/pigai/detail', { params: { id: this.idParam } })
        const payload = resp.data.result
        console.log('resp.result', resp)
        const requrepics = Array.isArray(payload && payload.picArrStr) ? payload.picArrStr : []
        const results = Array.isArray(payload && payload.resultPicArrStr) ? payload.resultPicArrStr : []
        this.images = requrepics.map((url, idx) => ({
          id: `${this.idParam}-pic-${idx}`,
          name: `图片${idx + 1}`,
          url,
          dataURL: url,
          order: idx,
          thumb: url
        }))
        this.create_time = payload.create_time || null
        this.beizhu = payload.beizhu || null
        this.piyu = payload.piyu || null

        this.corrections = results
      } catch (e) {
        console.error(e)
        this.images = []
        this.corrections = []
      }
    },

    async refreshImages() { return this.fetchDetail() },
    async refreshCorrections() { return this.fetchDetail() },
    onCorrectionUploaded() { this.fetchDetail() },
    triggerFile() { this.$refs.hiddenInput && this.$refs.hiddenInput.click() },
    onDrop(e) {
      const files = Array.from((e.dataTransfer && e.dataTransfer.files) || []).filter((f) => f.type && f.type.startsWith('image/'))
      if (files.length) this.handleFiles(files)
    },

    onFileSelect(e) {
      const input = e.target
      const files = Array.from((input.files) || [])
      input.value = ''
      this.handleFiles(files)
    },

    async handleFiles(files) {
      for (const file of files) {
        const id = this.uuid()
        const item = { id, name: file.name, progress: 0, status: '读取中' }
        this.uploads.push(item)
        const dataURL = await this.readFile(file, (p) => (item.progress = p))
        item.status = '生成缩略图'
        const thumb = await this.makeThumb(dataURL)
        const rec = { id, name: file.name, createdAt: Date.now(), dataURL, order: this.images.length, url: dataURL }
        this.images.push({ ...rec, thumb })
        item.status = '完成'
        item.progress = 100
      }
      setTimeout(() => (this.uploads = []), 800)
    },

    readFile(file, onProgress) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result))
        reader.onerror = () => reject(reader.error)
        reader.onprogress = (evt) => {
          if (evt.lengthComputable) onProgress(Math.round((evt.loaded / evt.total) * 100))
        }
        reader.readAsDataURL(file)
      })
    },

    makeThumb(dataURL) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const w = 180
          const ratio = img.height / img.width
          canvas.width = w
          canvas.height = Math.round(w * ratio)
          const c = canvas.getContext('2d')
          c.drawImage(img, 0, 0, canvas.width, canvas.height)
          resolve(canvas.toDataURL('image/png'))
        }
        img.src = dataURL
      })
    },

    openEditor(id) {
      const img = this.images.find(i => i.id === id)
      const url = img ? img.url || img.dataURL : null
      if (url) this.$router.push({ path: '/pigaiEditor', query: { id: img.id, url, pid: this.idParam } })
    },

    reopenEditor(url) {
      // 点击批改结果图片，重新进入批改页面进行二次批改
      if (!url) return
      // 找到该图片在 corrections 数组中的索引
      const correctionIndex = this.corrections.findIndex(c => c === url)
      if (correctionIndex === -1) {
        this.$message.warning('无法找到该批改结果')
        return
      }
      // 传递索引和原始URL，以便保存时替换
      this.$router.push({ 
        path: '/pigaiEditor', 
        query: { 
          id: this.idParam,
          url, 
          pid: this.idParam,
          correctionIndex // 传递索引，用于替换
        } 
      })
    },

    async onDelete(img) {
      // 本地移除展示项（不影响服务端数据）
      this.images = this.images.filter((i) => i.id !== img.id)
      this.corrections = this.corrections.filter((c) => c.beforeThumb !== img.url && c.afterThumb !== img.url)
    },

    onDragStart(idx) { this.dragIndex = idx },
    onDragEnter(idx) { this.overIndex = idx },

    async onDragEnd() {
      if (this.dragIndex === null || this.overIndex === null || this.dragIndex === this.overIndex) return
      const list = this.imagesSorted
      const moved = list[this.dragIndex]

      list.splice(this.dragIndex, 1)
      list.splice(this.overIndex, 0, moved)
      list.forEach((it, i) => (it.order = i))
      window.dispatchEvent(new Event('images-order-updated'))
      this.dragIndex = null
      this.overIndex = null
      this.images = list
    },

    async downloadAll() {
      this.downloading = true
      this.downloadProgress = 0
      this.downloadDone = false
      this.downloadFailed = []
      for (let i = 0; i < this.corrections.length; i++) {
        const url = this.corrections[i]
        try {
          await this.downloadDataURL(url, `result-${i + 1}.png`)
        } catch (e) {
          this.downloadFailed.push({ url, version: i + 1 })
        } finally {
          this.downloadProgress++
        }
      }
      this.downloading = false
      this.downloadDone = this.downloadFailed.length === 0
    },

    retryDownload() { this.downloadAll() },
    downloadDataURL(dataURL, filename) {
      return new Promise((resolve) => {
        const a = document.createElement('a')
        a.href = dataURL
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(resolve, 50)
      })
    },
    async clearAllCorrections() { this.corrections = [] },
    deleteResult(fullUrl) {
      const doDelete = async () => {
        try {
          const picUrl = this.stripDomain(fullUrl)
          const { data: res } = await this.$http.post('admin/pigai/deleteResultArrSinglePic', {
            id: this.idParam,
            picUrl
          })
          if (!res || res.code !== 200) {
            return this.$message.error((res && (res.message || (res.meta && res.meta.msg))) || '删除失败')
          }
          this.$message.success('已删除')
          this.fetchDetail()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }
      this.$confirm('确定删除该图片？', '提示', { type: 'warning' })
        .then(() => doDelete())
        .catch(() => { })
    },
    
    stripDomain(url) {
      try {
        if (!url) return ''
        if (/^data:/.test(url)) return ''
        if (url.startsWith('/')) return url
        const u = new URL(url)
        const path = u.pathname + (u.search || '')
        return path || url
      } catch (_) {
        const idx = url.indexOf('/uploads/')
        if (idx >= 0) return url.substring(idx)
        return url
      }
    },

    async submitCorrection() {
      if (!this.corrections.length || this.submitting) return
      this.submitting = true
      try {
        const resultStr = this.corrections.map((u) => this.stripDomain(u)).filter((s) => !!s).join(',')
        const { data: res } = await this.$http.post('admin/pigai/edit', {
          id: this.idParam,
          status: 2,
          resultPicArrStr: resultStr,
          piyu: this.piyu || ''
        })
        if (!res || res.code !== 200) {
          this.$message.error((res && (res.message || (res.meta && res.meta.msg))) || '完成批注失败')
          return
        }
        this.$message.success('完成批注成功')
        this.goBack()
      } catch (e) {
        this.$message.error('完成批注失败')
      } finally {
        this.submitting = false
      }
    },

    uuid() {
      // simple UUID
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  }
}
</script>

<style scoped>
.page {
  padding: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.upload-btn {
  cursor: pointer;
  padding: 6px 12px;
  border: 1px dashed #ccc;
  border-radius: 4px;
}

.upload-btn input {
  display: none;
}

.dropzone {
  margin: 12px 0;
  padding: 12px;
  border: 2px dashed #ddd;
  border-radius: 6px;
  min-height: 80px;
}

.drop-hint {
  color: #999;
}

.upload-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 10px;
}

.upload-item {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px;
}

.upload-item .bar {
  height: 6px;
  background: #f5f5f5;
  border-radius: 3px;
  overflow: hidden;
  margin: 4px 0;
}

.upload-item .progress {
  height: 100%;
  background: #67c23a;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.card {
  position: relative;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px;
  background: #fff;
}

.thumb {
  width: 100%;
  display: block;
  border-radius: 4px;
  cursor: pointer;
}

.delete {
  position: absolute;
  right: 8px;
  top: 8px;
}

.meta.vertical {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.history {
  margin-top: 16px;
}

.hist-title {
  display: flex;
  align-items: center;
}

.hist-title .refresh {
  margin-left: 12px;
  padding: 4px 8px;
  font-size: 12px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.hist-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.hist-item {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px;
  width: 230px;
}

.hist-item img {
  width: 100%;
  border-radius: 4px;
}

.download-bar {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.review-bar {
  margin-top: 12px;
  display: flex;
  gap: 12px;
}
.piyu-input {
  flex: 1;
  min-height: 60px;
}
.submit {
  min-width: 120px;
}

.hidden {
  display: none;
}
</style>